import React, { Component } from 'react';
import PageHeaderWithBackButton from '../../../../shared/headers/PageHeaderWithBackButton';
import { alert_headers } from '../../../../model/alerts/alert-headers';
import { fetchAlerts } from '../list/redux/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../../services/Paging';
import { AlertsTable } from '../../../../shared/table/AlertsTable';
import { isEqual } from 'lodash';
import {
    getSelectedBrandId,
    getSelectedJurisdictionCode
} from '../../../../jurisdiction/redux/selectors';
import { makeRuleTypeDropdownOptions } from '../../../../shared/models/rule-type';

class DismissedAlerts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                pageSize: defaultItemsPerPage,
                page: defaultFirstPage
            },
            sort: {},
            filters: {
                type: null,
                severity: null
            }
        };
    }

    componentDidMount() {
        this.fetchDismissedAlertsFromState();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            !isEqual(prevProps.jurisdictionCode, this.props.jurisdictionCode) ||
            !isEqual(prevProps.brandId, this.props.brandId)
        ) {
            this.fetchDismissedAlertsFromState();
        }
    }

    makeFiltersConfig = () => ({
        typeConfig: {
            label: 'Rule Type',
            options: makeRuleTypeDropdownOptions()
        },
        severityConfig: {},
        statusConfig: null
    });

    handleApplyFilters = filters => {
        this.setState(
            {
                ...this.state,
                pagination: {
                    ...this.state.pagination,
                    page: defaultFirstPage
                },
                filters
            },
            () => this.fetchDismissedAlertsFromState()
        );
    };

    handleClearFilters = filters =>
        this.setState(
            {
                ...this.state,
                pagination: {
                    pageSize: defaultItemsPerPage,
                    page: defaultFirstPage
                },
                filters
            },
            () => this.fetchDismissedAlertsFromState()
        );

    handleRemoveFilter = filters =>
        this.setState(
            {
                ...this.state,
                filters
            },
            () => this.fetchDismissedAlertsFromState()
        );

    handleSearchByUsername = username =>
        this.setState(
            {
                ...this.state,
                pagination: {
                    ...this.state.pagination,
                    page: defaultFirstPage
                },
                username
            },
            () => this.fetchDismissedAlertsFromState()
        );

    fetchDismissedAlertsFromState() {
        const { fetchAlerts, location, jurisdictionCode, brandId } = this.props;
        const { pagination, sort, filters, username } = this.state;

        fetchAlerts &&
            fetchAlerts({
                ruleCategory: location.state.ruleCategory,
                jurisdictionCode,
                brandId,
                dismissed: true,
                pagination,
                sort: {
                    sortType: sort.sortingKey,
                    sortOrder: sort.sortDirection
                },
                ruleType: filters.type,
                alertLevel: filters.severity,
                username
            });
    }

    updatePagination = pagination =>
        this.setState(
            {
                ...this.state,
                pagination
            },
            () => this.fetchDismissedAlertsFromState()
        );

    updateSort = sort =>
        this.setState(
            {
                ...this.state,
                sort
            },
            () => this.fetchDismissedAlertsFromState()
        );

    render() {
        const { alerts, pagination, loading } = this.props;

        return (
            <span className="alerts-main-container container">
                <PageHeaderWithBackButton />
                <AlertsTable
                    headers={alert_headers}
                    data={alerts}
                    loading={loading}
                    pagination={{
                        ...this.state.pagination,
                        hasNextPage: pagination.hasNextPage
                    }}
                    onPaginationUpdated={pagination =>
                        this.updatePagination(pagination)
                    }
                    onSortUpdated={sort => this.updateSort(sort)}
                    filters={this.state.filters}
                    filtersConfig={this.makeFiltersConfig()}
                    applyFilters={this.handleApplyFilters}
                    clearFilters={this.handleClearFilters}
                    removeFilter={this.handleRemoveFilter}
                    searchByUsername={this.handleSearchByUsername}
                />
            </span>
        );
    }
}

const mapStateToProps = state => {
    const { pagination, loaded, loading, error, data } = state.alerts;
    const jurisdictionCode = getSelectedJurisdictionCode(state);
    const brandId = getSelectedBrandId(state);
    return {
        jurisdictionCode,
        brandId,
        alerts: data,
        pagination,
        loaded,
        loading,
        error
    };
};
const mapDispatchToProps = dispatch => ({
    fetchAlerts: args => {
        dispatch(fetchAlerts(args));
    }
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(DismissedAlerts)
);
